import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    credential: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect path from location state (passed from VIP page etc.)
  const from = location.state?.from || '/';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.credential, formData.password);
    
    if (result.success) {
      // Navigate back to the original page (e.g., /vip) or home
      navigate(from, { replace: true });
    } else {
      setError(result.message || 'Login failed, please check your credentials');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-page premium-page">
      <div className="auth-page__bg" />

      <div className="auth-card">
        <button
          type="button"
          className="auth-card__close"
          onClick={() => navigate('/')}
          aria-label="Close"
        >
          <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        <div className="auth-card__header">
          <Link to="/" className="auth-card__logo">
            <svg viewBox="0 0 24 24" fill="none" width="40" height="40">
              <path d="M3 17L9 11L13 15L21 7" stroke="url(#auth-logo)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M17 7H21V11" stroke="url(#auth-logo)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <defs>
                <linearGradient id="auth-logo" x1="3" y1="7" x2="21" y2="17" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#60a5fa"/>
                  <stop offset="1" stopColor="#1d4ed8"/>
                </linearGradient>
              </defs>
            </svg>
          </Link>
          <h1 className="auth-card__title">Welcome Back</h1>
          <p className="auth-card__subtitle">Sign in to your account</p>
        </div>

        {error && (
          <div className="auth-card__error">
            <span>⚠️ {error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-form__field">
            <label htmlFor="credential">Email or Username</label>
            <input
              type="text"
              id="credential"
              name="credential"
              value={formData.credential}
              onChange={handleChange}
              placeholder="your@email.com or username"
              required
            />
          </div>

          <div className="auth-form__field">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
            />
          </div>

          <div style={{ textAlign: 'right', marginTop: '-8px', marginBottom: '4px' }}>
            <Link to="/forgot-password" style={{ fontSize: '13px', color: 'var(--text-secondary, #64748b)' }}>
              Forgot password?
            </Link>
          </div>

          <button 
            type="submit" 
            className={`auth-form__submit ${loading ? 'auth-form__submit--loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-form__spinner"></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="auth-card__footer">
          <p>Don't have an account? <Link to="/register">Get Started</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;

